<template>
    <transition name="fade">
        <div v-if="showApp" id="app">
            <div class="left-column">
                <div class="login-header">
                    <img src="./assets/main4.png" height="60px" />
                </div>
                <div class="center">
                    <SignIn />
                </div>
                <div class="footer">
                    <div class="links"></div>
                    <div class="version">Version 1.11.16</div>
                </div>
            </div>

            <div class="right-column">
                <!-- Layer A -->
                <div
                        class="bg-layer"
                        :class="{
            'is-top': topLayer === 'A',
            'is-next': nextUp === 'A',
            'is-fading-out': fadingOutTop && topLayer === 'A',
          }"
                        :style="layerAStyle"
                ></div>

                <!-- Layer B -->
                <div
                        class="bg-layer"
                        :class="{
            'is-top': topLayer === 'B',
            'is-next': nextUp === 'B',
            'is-fading-out': fadingOutTop && topLayer === 'B',
          }"
                        :style="layerBStyle"
                ></div>

                <section class="copy"

                >
                    <p style="font-size: 20px !important;" >
                        <strong style="font-size: 22px !important;"  >
                            첨단 위조방지라벨 |  불법유통차단 솔루션 | 유통 물류 추적솔루션</strong> <br />
                        전세계 최초의 나노신소재 + 정품인정 IT 솔루션<br />
                        짝퉁 원천 차단과 불법유통차단을 동시에 !<br />
                        1,000여 기업의 다양한 적용 사례 컨설팅 경험
                    </p>
                </section>
            </div>
        </div>
    </transition>
</template>

<script>
import SignIn from "@/views/components/SignIn.vue";
import Axios from "axios";

export default {
    name: "download",
    components: { SignIn },

    data() {
        return {
            showApp: false,
            images: [
                require("./resource/sign_in_bg2.jpg"),
                require("./resource/sign_in_bg1.jpg"),
                require("./resource/sign_in_bg2.jpg"),
            ],
            curIndex: 0,
            nextIndex: 1,

            // 레이어 소스
            srcA: "",
            srcB: "",

            // 어떤 레이어가 화면 맨 위인가
            topLayer: "A", // 'A' | 'B'

            // 전환 플래그
            nextUp: null, // 'A' | 'B' | null  (올라올 레이어)
            fadingOutTop: false, // 현재 top이 서서히 사라지는지

            fadeMs: 3000, // 배경 페이드 시간 (조금 더 자연스럽게 0.8s)
            intervalMs: 5000, // 유지 시간
            timer: null,
            busy: false,
            mobileFlag : false,
            gps : '',
            latitude : '',
            longitude : '',
            formatted_address : '',
            country : '',
            administrative_area_level_1 : '',
            lang : '',
            orgLang : '',
        };
    },

    computed: {
        layerAStyle() {
            return {
                backgroundImage: `linear-gradient(rgba(0,0,0,0), rgba(0,0,0,0.5)), url(${this.srcA})`,
            };
        },
        layerBStyle() {
            return {
                backgroundImage: `linear-gradient(rgba(0,0,0,0), rgba(0,0,0,0.5)), url(${this.srcB})`,
            };
        },
    },

    created() {

        // console.log ("this.$route.query.url : "+ this.$route.query.url);
        //
        // if (this.$route.query.url != null ) {
        //
        //   console.log ("this.$route.query.url : "+ this.$route.query.url);
        //
        //   const url = this.$route.query.url;
        //
        //   this.$router.push({ name: url })
        // }


        var lang = navigator.language
        this.lang = lang.substring(0,2).toLowerCase();
        this.orgLang =  lang;

        console.log( "===============" +  lang.toLowerCase() ) ;
        console.log( "===============" +  this.orgLang.toLowerCase() ) ;





        if (this.$route.query.Auth != null ) {
            //console.log ("Login this.$route.query.Auth : "+ this.$route.query.Auth);
            this.gotoAuth();
        }
        else if (this.$route.query.A != null ) {
            //console.log ("Login this.$route.query.A : "+ this.$route.query.A);
            this.gotoAuth();
        }
        else {
            this.mobileFlag = true;
        }


        var agent = window.navigator.userAgent.toLowerCase();
        var appName = window.navigator.appName.toLowerCase();

        if((appName === 'netscape' && agent.indexOf('trident')!== -1) || agent.indexOf('msie') !== -1)
        {
            if(confirm("현재 페이지는 인터넷익스플로러(IE)브라우저를 지원하지 않습니다. " + "크롬 혹은 엣지브라우저에서 정상적으로 작동됩니다. 해당 브라우저로 이동하시겠습니까?"))
            { window.location = "microsoft-edge:" + window.location.href; }
        }


        // this.allCountryUpdate();
    },

    async mounted() {
        // 초기 로드
        await this.preload(this.images[this.curIndex]);
        await this.preload(this.images[this.nextIndex]);
        this.srcA = this.images[this.curIndex];
        this.srcB = this.images[this.nextIndex];
        this.topLayer = "A";

        this.showApp = true;

        this.timer = setInterval(this.crossfade, this.intervalMs);
    },

    beforeDestroy() {
        if (this.timer) clearInterval(this.timer);
    },

    methods: {

        async  allCountryUpdate(){


            console.log("==============allCountryUpdate================");
            console.log(this.totalData);

            let url = this.$url + '/authInfo/updateList';
            var reqJson = new Object();

            await Axios.post(url, reqJson , this.$store.state.config ).then(res => {
                var resDataJson = res.data.authInfoDTO;


                console.log("==============/authInfo/updateList================");
                console.log(resDataJson);

                // this.totalData=[];
                if (res.data.resultCode){

                    for (var resData in resDataJson) {
                        this.getaddress( resDataJson[resData]['latitude'] , resDataJson[resData]['longitude'], resDataJson[resData]['auth_info_seq']    )
                    }

                }else{
                    // this.$message.error(this.$store.state.dataNotFound);
                    // this.currentPage = 1;
                    // this.loading = false;
                }




            }) // await Axios.post
                .catch(error => {
                    console.log(error.response)
                    // this.$message.error(this.$store.state.serverErrorMessage);
                    // this.currentPage = 1;
                    // this.loading = false;
                }); // await Axios.post
        }, //allCountryUpdate



        async getaddress(latitude,  longitude, auth_info_seq ) {



            let url2  = "https://maps.googleapis.com/maps/api/geocode/json?latlng="+latitude +","+ longitude +"&key=AIzaSyA1LUF3e_P4F_vrT24zIJDy9p96eRJQmdg&language=ko"
            console.log("==============URL URL================");
            console.log(url2);


            await Axios.get(url2 ).then(res => {

                console.log("==============URL RESULT ================");
                console.log(res.data['results'][0]['formatted_address']);

                this.formatted_address = res.data['results'][0]['formatted_address'] ;

                for(var i=0 ; i< res.data['results'][0]['address_components'].length   ; i++) {
                    if (res.data['results'][0]['address_components'][i]['types'][0] == "country")
                        this.country= res.data['results'][0]['address_components'][i]['long_name']   ;

                    if (res.data['results'][0]['address_components'][i]['types'][0] == "administrative_area_level_1")
                        this.administrative_area_level_1 = res.data['results'][0]['address_components'][i]['long_name']  ;
                }

                this.totalData = [];

                this.totalData.push({
                    auth_info_seq: auth_info_seq
                    , country: this.country
                    , administrative_area_level_1: this.administrative_area_level_1
                    , formatted_address: this.formatted_address
                });
                console.log("==============totalDatatotalDatatotalData================");
                console.log(this.totalData);
                this.updateAddress(this.totalData);

            }) // await Axios.post
                .catch(error => {
                    console.log(error.response)
                }); // await Axios.post

        },



        async updateAddress(reqDataJson){

            let url = this.$url + '/authInfo/updateAddress';

            console.log("==============updateAddressupdateAddressupdateAddress================");
            console.log(reqDataJson);

            this.loading = true;
            await Axios.post(url, reqDataJson , this.$store.state.config ).then(res => {
                let saveCount = res.data;
                if (saveCount){
                    // this.$message.success(saveCount +'건 ' + this.$store.state.saveSuccess);

                }else{
                    // this.$message.error(this.$store.state.serverErrorMessage);
                    // this.currentPage = 1;

                }

                this.loading = false;
            }) // await Axios.post
                .catch(error => {
                    console.log(error.response)
                    // this.$message.error(this.$store.state.serverErrorMessage);
                    // this.currentPage = 1;
                    // this.loading = false;
                }); // await Axios.post
        },


        async gotoAuth(){
            // default data
            let url = this.$url + '/rfidGetOrder/getAuthGubun';
            var reqJson = new Object();
            var auth_gubun= '';




            if (this.$route.query.Auth != null ) {
                reqJson.auth_code = this.$route.query.Auth;
            }
            else if (this.$route.query.A != null ) {
                reqJson.auth_code = this.$route.query.A;
            }



            await Axios.post(url, reqJson , this.$store.state.config ).then(res => {
                var resDataJson = res.data.rfidGetOrderDto;

                //console.log (" resD/ataJson " + resDataJson ) ;

                if (res.data.resultCode){
                    for (var resData in resDataJson) {

                        auth_gubun =  resDataJson[resData]['auth_gubun']
                    }

                }else{
                    this.$message.error(this.$store.state.dataNotFound);

                }
            }) // await Axios.post
                .catch(error => {
                    console.log(error.response)
                    this.$message.error(this.$store.state.serverErrorMessage);
                    this.currentPage = 1;
                    this.loading = false;
                }); // await Axios.post


            console.log (" auth_gubunauth_gubunauth_gubun" + auth_gubun ) ;

            if (this.$route.query.Auth != null ) {
                if (auth_gubun == '1')
                    this.$router.push({name: 'mobile', query: {Auth: this.$route.query.Auth}});
                else if (auth_gubun == '2')
                    this.$router.push({name: 'mobile2', query: {Auth: this.$route.query.Auth}});
                else if (auth_gubun == '144')
                    this.$router.push({name: 'mobile144', query: {Auth: this.$route.query.Auth}});

            } else if (this.$route.query.A != null ) {
                if (auth_gubun == '1')
                    this.$router.push({name: 'mobile', query: {Auth: this.$route.query.A}});
                else if (auth_gubun == '2')
                    this.$router.push({name: 'mobile2', query: {Auth: this.$route.query.A}});

                else if (auth_gubun == '3')
                    this.$router.push({name: 'mobile3', query: {Auth: this.$route.query.A}});

                else if (auth_gubun == '144')
                    this.$router.push({name: 'mobile144', query: {Auth: this.$route.query.A}});

            }

        },


        download() {
            try {
                let element = document.createElement('a');
                element.setAttribute('href','/download');
                element.click();
            } catch(error) {
                console.log(error)
            }
        },


        preload(src) {
            return new Promise((resolve) => {
                const img = new Image();
                img.src = src;
                if (img.decode) {
                    img
                        .decode()
                        .then(resolve)
                        .catch(resolve);
                } else {
                    img.onload = resolve;
                    img.onerror = resolve;
                }
            });
        },

        async crossfade() {
            if (this.busy) return;
            this.busy = true;

            // 1) 숨겨진 레이어에 다음 이미지를 세팅
            const hiddenLayer = this.topLayer === "A" ? "B" : "A";
            const nextSrc = this.images[this.nextIndex];
            await this.preload(nextSrc);
            if (hiddenLayer === "A") this.srcA = nextSrc;
            else this.srcB = nextSrc;

            // 2) 동시 크로스페이드 시작
            // - 올라올 레이어: is-next(0→1)
            // - 현재 top 레이어: is-fading-out(1→0)
            this.nextUp = hiddenLayer;
            this.fadingOutTop = true;

            // 3) 페이드가 끝난 뒤에만 레이어 스왑 및 플래그 정리
            setTimeout(() => {
                this.topLayer = hiddenLayer; // 이제 hidden이 top
                this.nextUp = null; // is-next 제거
                this.fadingOutTop = false; // is-fading-out 제거

                // 인덱스 갱신
                this.curIndex = this.nextIndex;
                this.nextIndex = (this.nextIndex + 1) % this.images.length;

                this.busy = false;
            }, this.fadeMs);
        },
    },
};
</script>

<style scoped>
/* ===== 레이아웃 ===== */
#app {
    display: flex;
}
.left-column,
.right-column {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

/* 데스크톱: 24% / 76% */
@media screen and (min-width: 900px) {
    #app {
        flex-direction: row;
        height: 100vh;
    }
    .left-column {
        display: flex;
        width: 24%;
        height: 100vh;
    }
    .right-column {
        display: flex;
        width: 76%;
        height: 100vh;
    }
    .login-header,
    .center,
    .footer {
        width: 70%;
    }
    .login-header img {
        width: 100%;
        height: 90%;
        padding: 20px;
    }
}

/* 모바일 */
@media screen and (max-width: 899px) {
    #app {
        flex-direction: column;
    }
    .login-header,
    .center,
    .footer {
        width: 70%;
    }
    .version {
        float: right;
    }
    .left-column {
        display: flex;
        padding: 40px;
        background: rgb(255 255 255 / 0.9);
        margin: 50% 50px;
        border-radius: 20px;
        justify-content: center;
        align-items: center;
        z-index: 2;
    }
    .right-column .copy {
        display: none;
    }
    .right-column {
        position: fixed;
        bottom: 0;
        width: 100vw;
        height: 100vh;
    }
}

/* ===== 배경 전환 ===== */
.right-column {
    position: relative;
    overflow: hidden;
}
.bg-layer {
    position: absolute;
    inset: 0;
    background-size: cover;
    background-position: center;
    will-change: opacity, transform;
    backface-visibility: hidden;
    transform: translateZ(0);
    contain: paint;

    /* 핵심: 양쪽 모두 opacity 트랜지션 */
    transition: opacity var(--fade, 800ms) ease-in-out;

    /* 옵션: 좌우 패닝 모션 (튐이 느껴지면 아래 줄을 주석 처리) */
    animation: bg-pan 30s linear infinite;
}

/* 기본은 안 보임 */
.bg-layer {
    opacity: 0;
}

/* 현재 화면에 보이는 레이어 */
.bg-layer.is-top {
    opacity: 1;
}

/* 올라올 레이어 (0→1) */
.bg-layer.is-next {
    opacity: 1;
}

/* 내려갈 레이어 (1→0) */
.bg-layer.is-fading-out {
    opacity: 0;
}

/* 카피 영역 */
.right-column .copy {
    position: relative;
    z-index: 3;
    color: white;
    text-align: center;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}
.right-column p {
    font-size: 2.5rem;
    font-weight: 400;
}

/* 배경 패닝(옵션) */
@keyframes bg-pan {
    0% {
        background-position: left;
    }
    50% {
        background-position: right;
    }
    100% {
        background-position: left;
    }
}

/* ===== 화면(컴포넌트) 전환 페이드 ===== */
.fade-enter-active,
.fade-leave-active {
    transition: opacity 300ms ease;
}
.fade-enter,
.fade-leave-to {
    opacity: 0;
}
</style>

<style>
/* 기존 글로벌 스타일 유지 */
@media screen and (max-width: 899px) {
    h2 {
        text-align: left;
    }
}
h2 {
    color: #8b8c8f;
    font-size: 2rem;
    font-weight: normal;
    margin: 26.56px 0 !important;
    padding: 0 !important;
}
.el-input__inner {
    display: block;
    width: 100% !important;
    box-sizing: border-box;
    border-radius: 8px;
    border: 1px solid #c4c4c4;
    padding: 1em !important;
    font-size: 0.875rem;
    outline-color: #10a361;
}
.el-button.login-button:hover {
    background-color: #012a53;
    color: #fff;
}
.el-button.login-button {
    display: block;
    width: 100%;
    background-color: rgb(1, 50, 99);
    color: #fff;
    font-weight: 700;
    border: none;
    padding: 1rem;
    border-radius: 8px;
    font-size: 1rem;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}
.el-card {
    border: none !important;
    background: transparent !important;
}
.el-card.is-always-shadow,
.el-card.is-hover-shadow:focus,
.el-card.is-hover-shadow:hover {
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0) !important;
}
.login-header {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 15px !important;
}
.footer {
    padding-top: 20px;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
}
.el-table {
    font-family: "Segoe UI", "Malgun Gothic";
    font-size: 9px !important;
}
.bg-purple-light {
    background: #f3f5f2;
}
.grid-content {
    border-radius: 4px;
    min-height: 36px;
}
.el-row {
    margin-bottom: 10px;
}
.el-col {
    border-radius: 4px;
}
.el-table th > .cell {
    height: 42px !important;
    display: flex !important;
    align-items: center !important;
}
.el-table .cell {
    display: flex !important;
    align-items: center !important;
    height: 30px !important;
    line-height: 30px;
}
.pagination {
    height: 52px !important;
    display: flex !important;
    align-items: center !important;
}
.el-button--primary {
    color: #fff;
    background-color: #409eff;
    border-color: #409eff;
    height: 9px !important;
    display: flex !important;
    align-items: center !important;
}
.searchTitle {
    height: 30px !important;
    width: 82px !important;
    font-size: 11px !important;
    align-items: center !important;
    margin-left: 10px !important;
    display: flex !important;
}
.searchBody {
    height: 40px !important;
    font-size: 10px !important;
    align-items: center !important;
    margin-left: 10px !important;
    display: flex !important;
}
.searchBody_brand {
    width: 50px !important;
}
.searchBody_year {
    width: 50px !important;
    margin-left: 20px !important;
}
.searchBody_season {
    width: 50px !important;
    margin-left: 20px !important;
}
.searchBody_production {
    width: 50px !important;
    margin-left: 20px !important;
}
.mappingDate {
    width: 50px !important;
    margin-left: 20px !important;
    margin-right: 30px !important;
}
.el-input--mini .el-input__inner {
    height: 20px !important;
    width: 100px !important;
    border: 1px solid #f29659 !important;
    border-radius: 4px !important;
    box-sizing: border-box !important;
    font-size: 9px !important;
    cursor: pointer !important;
    padding: 0 6px !important;
}
.el-select .el-input .el-select__caret {
    color: #f29659;
    width: 20px !important;
    height: 20px !important;
    font-size: 9px !important;
    align-items: center !important;
    margin-left: 0px !important;
    display: flex !important;
}
.el-icon-arrow-up:before {
    margin-left: 3px !important;
    display: flex !important;
}
.el-select-dropdown__item.selected {
    color: #f29659 !important;
    font-size: 9px !important;
    font-weight: 0 !important;
}
::after,
::before {
    font-size: 11px !important;
}
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
    width: auto !important;
}
.searchBody_barcode {
    width: 80px !important;
    margin-left: 20px !important;
}
</style>
